import { comments } from '@/mocks/articles';

export default function HotComments() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-7xl">
          <div className="text-center mb-10 md:mb-14">
            <div className="flex items-center justify-center gap-2 mb-3">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-widest">
                瓜友神评
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              真实爆料
              <br />
              在线追踪
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              来看看瓜友们都在讨论什么
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {comments.map((comment) => (
              <div
                key={comment.id}
                className="bg-background-50 rounded-2xl p-5 md:p-6"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-sm ${
                        i < comment.stars ? 'text-secondary-500' : 'text-background-300'
                      }`}
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed line-clamp-4 mb-4">
                  &ldquo;{comment.content}&rdquo;
                </p>
                <div className="flex items-center gap-3 pt-4 border-t border-background-100">
                  <img
                    src={comment.avatar}
                    alt={comment.username}
                    className="w-9 h-9 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">
                      {comment.username}
                    </p>
                    <p className="text-xs text-foreground-500">{comment.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}